"use client";
import { Children, cloneElement, MouseEvent, ReactElement } from "react";
import { useModal } from "../ModalRoot/ModalRoot";

interface ModalTriggerProps {
  children: ReactElement<{
    onClick?: (e: MouseEvent<HTMLElement>) => void;
    "aria-haspopup"?: "dialog";
  }>;
}

const ModalTrigger = ({ children }: ModalTriggerProps) => {
  const { setOpen } = useModal();
  return Children.map(children, (child) =>
    cloneElement(child, {
      "aria-haspopup": "dialog",
      onClick: (e: MouseEvent<HTMLElement>) => {
        child.props.onClick?.(e);
        setOpen(true);
      },
    }),
  );
};

export default ModalTrigger;
